export default __webpack_public_path__ + "static/media/Imp_hitch_avl_red.543502b2.svg";